<template>
    <header class="app-header navbar">
        <vue-snotify></vue-snotify>
        <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
            <span class="navbar-toggler-icon" />
        </button>
        <b-link class="navbar-brand" to="#"/>
        <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
            <span class="navbar-toggler-icon" />
        </button>
        <b-navbar-nav class="ml-auto">
            <header-dropdown v-if="user && user.id" :user="user"/>
            <template v-else>
                <button type="button" class="btn btn-light mr-1" v-b-modal.register-modal><i class="fa fa-user-plus" /> Register</button>
                <button type="button" class="btn btn-light mr-1" v-b-modal.login-modal><i class="fa fa-sign-in" /> Login</button>
            </template>
        </b-navbar-nav>
        <login-modal></login-modal>
        <register-modal></register-modal>
    </header>
</template>
<script>
import HeaderDropdown from './HeaderDropdown.vue'
import LoginModal from './LoginModal.vue'
import RegisterModal from './RegisterModal.vue'
export default {
    name      : 'CHeader',
    components: { HeaderDropdown, LoginModal, RegisterModal },
    props     : {
        fixed: {
            type   : Boolean,
            default: true,
        },
    },
    computed: {
        user(){
            return this.$store.get('user/user');
        },
    },
    mounted () {
        if (this.fixed) $('body').addClass('header-fixed')
    },
    beforeDestroy () {
        $('body').removeClass('header-fixed')
    },
    methods: {
        sidebarToggle (e) {
            e.preventDefault()
            document.body.classList.toggle('sidebar-hidden')
        },
        sidebarMinimize (e) {
            e.preventDefault()
            document.body.classList.toggle('sidebar-minimized')
        },
        mobileSidebarToggle (e) {
            e.preventDefault()
            document.body.classList.toggle('sidebar-mobile-show')
        },
    },
}

</script>
